<script setup>
import { defineProps } from 'vue';
import { useRouter } from 'vue-router'
import { $vfm } from 'vue-final-modal';

/**
 * header:
 * {
 *      text: '雲端ｅ櫃台',
 *      backBtn: { visible: true },
 *      closeBtn: { visible: false, to: {} },
 * }
 */
const props = defineProps({
    header: Object
});


const router = useRouter();

const backHandle = () => {
    router.go(-1);
}

const closeHandle = () => {
    if (props.header?.closeBtn?.to) {
        $vfm.show({
            component: 'DialogBase',
            params: {
                title: '系統提示',
                content: '請確認取消本項變更',
                confirmButton: '確認',
                cancelButton: '取消',
                closeicon: false,
            },
            on: {
                confirm() {
                    $vfm.hide('DialogBase');
                    router.push(props.header.closeBtn.to);
                },
                cancel() {
                    $vfm.hide('DialogBase');
                },
            },
        });
    }
}

</script>

<template>

    <div class="header bg-white fill-[#0093C1]">

        <div class="flex max-w-[768px] mx-auto h-[60px]">
            <div class="w-11">
                <button @click="backHandle" class="w-full h-full" v-if="header.backBtn?.visible">
                    <svg class="mx-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                        style="height: 24px;width: 24px;">
                        <title>chevron-left</title>
                        <path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
                    </svg>
                </button>
            </div>
            <div class="flex-1 text-center py-4">
                <h1 class="text-lg font-bold">
                    <template v-if="header.text">
                        {{ header.text }}
                    </template>
                    <slot v-else></slot>
                </h1>
            </div>
            <div class="w-11">
                <button class="w-full h-full" @click="closeHandle" v-if="header?.closeBtn?.visible">
                    <svg class="mx-auto" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                        style="height: 24px;width: 24px;">
                        <title>close</title>
                        <path
                            d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                    </svg>
                </button>
            </div>
        </div>


    </div>

</template>

<style scoped>
.header {
    box-shadow: 0px 2px 12px 0px #0C0E1F0A;
}
</style>
